// extracted by mini-css-extract-plugin
export default {"container":"m3oYVPLL","icon":"O2khIMww","disabled":"Hz_3Tm4Q","icon-wrapper":"cAAhDZj9","iconWrapper":"cAAhDZj9","text":"vvQKF4lC"};